module.exports = __webpack_public_path__ + "static/media/maintenance.d9126cd1.png";